import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function Main() {
  const navigate = useNavigate();
  const p = useParams();
  useEffect(() => {
    navigate("/start/" + p.id);
    return () => {};
  }, [navigate, p.id]);

  return <div></div>;
}
